import { openOverlay } from "overlay"
import WhatsNew from "./WhatsNew.svelte"

export function openWhatsNewOverlay() {
	openOverlay(WhatsNew, { classOverlay: "no-min whats-new" })
}
